import { APP_INSTANCE_ENUMS } from '../constants/app-instance-enums';
import Browser from './browser';

const { MOBILE_SDK, MOBILE_WEB, WEB } = APP_INSTANCE_ENUMS;

const getAppInstance = () => {
  const isMobileSdk = Browser.isHybridImplementation();
  if (isMobileSdk) {
    return MOBILE_SDK;
  } else if (
    Browser.isMobileSafari() ||
    Browser.isChromeOniOS() ||
    Browser.isIOSAndroid() ||
    Browser.isAndroidMobile()
  ) {
    return MOBILE_WEB;
  }
  return WEB;
};

export default getAppInstance;
